/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

export class SubCommandExecutor {
	private static commandExecutorsByCommandName: {[commandName: string]: (targetObject: any, command: any) => void} = {
		    'UiField.setVisible': (targetObject: any, command: any) => {
				targetObject.setVisible(command.visible);
			},
		    'UiComponentField.setComponent': (targetObject: any, command: any) => {
				targetObject.setComponent(command.component);
			},
		    'UiComponentField.setSize': (targetObject: any, command: any) => {
				targetObject.setSize(command.width, command.height);
			},
		    'UiComponentField.setBorder': (targetObject: any, command: any) => {
				targetObject.setBorder(command.border);
			},
		    'UiComponentField.setBackgroundColor': (targetObject: any, command: any) => {
				targetObject.setBackgroundColor(command.backgroundColor);
			},
		    'UiTextField.setMaxCharacters': (targetObject: any, command: any) => {
				targetObject.setMaxCharacters(command.maxCharacters);
			},
		    'UiTextField.setShowClearButton': (targetObject: any, command: any) => {
				targetObject.setShowClearButton(command.showClearButton);
			},
		    'UiTextField.setEmptyText': (targetObject: any, command: any) => {
				targetObject.setEmptyText(command.emptyText);
			},
		    'UiPasswordField.setSendValueAsMd5': (targetObject: any, command: any) => {
				targetObject.setSendValueAsMd5(command.sendValueAsMd5);
			},
		    'UiPasswordField.setSalt': (targetObject: any, command: any) => {
				targetObject.setSalt(command.salt);
			},
		    'UiMultiLineTextField.setMinHeight': (targetObject: any, command: any) => {
				targetObject.setMinHeight(command.minHeight);
			},
		    'UiMultiLineTextField.setMaxHeight': (targetObject: any, command: any) => {
				targetObject.setMaxHeight(command.maxHeight);
			},
		    'UiMultiLineTextField.append': (targetObject: any, command: any) => {
				targetObject.append(command.s, command.scrollToBottom);
			},
		    'UiRichTextEditor.setMinHeight': (targetObject: any, command: any) => {
				targetObject.setMinHeight(command.minHeight);
			},
		    'UiRichTextEditor.setMaxHeight': (targetObject: any, command: any) => {
				targetObject.setMaxHeight(command.maxHeight);
			},
		    'UiRichTextEditor.setUploadUrl': (targetObject: any, command: any) => {
				targetObject.setUploadUrl(command.uploadUrl);
			},
		    'UiRichTextEditor.setMaxImageFileSizeInBytes': (targetObject: any, command: any) => {
				targetObject.setMaxImageFileSizeInBytes(command.maxImageFileSizeInBytes);
			},
		    'UiRichTextEditor.setUploadedImageUrl': (targetObject: any, command: any) => {
				targetObject.setUploadedImageUrl(command.fileUuid, command.url);
			},
		    'UiRichTextEditor.setToolbarVisibilityMode': (targetObject: any, command: any) => {
				targetObject.setToolbarVisibilityMode(command.toolbarVisibilityMode);
			},
		    'UiDisplayField.setShowBorder': (targetObject: any, command: any) => {
				targetObject.setShowBorder(command.showBorder);
			},
		    'UiDisplayField.setShowHtml': (targetObject: any, command: any) => {
				targetObject.setShowHtml(command.showHtml);
			},
		    'UiLabel.setCaption': (targetObject: any, command: any) => {
				targetObject.setCaption(command.caption);
			},
		    'UiLabel.setIcon': (targetObject: any, command: any) => {
				targetObject.setIcon(command.icon);
			},
		    'UiImageField.setSize': (targetObject: any, command: any) => {
				targetObject.setSize(command.width, command.height);
			},
		    'UiImageField.setBorder': (targetObject: any, command: any) => {
				targetObject.setBorder(command.border);
			},
		    'UiImageField.setShadow': (targetObject: any, command: any) => {
				targetObject.setShadow(command.shadow);
			},
		    'UiImageField.setImageSizing': (targetObject: any, command: any) => {
				targetObject.setImageSizing(command.imageSizing);
			},
		    'UiNumberField.setMinValue': (targetObject: any, command: any) => {
				targetObject.setMinValue(command.min);
			},
		    'UiNumberField.setMaxValue': (targetObject: any, command: any) => {
				targetObject.setMaxValue(command.max);
			},
		    'UiNumberField.setSliderMode': (targetObject: any, command: any) => {
				targetObject.setSliderMode(command.sliderMode);
			},
		    'UiNumberField.setSliderStep': (targetObject: any, command: any) => {
				targetObject.setSliderStep(command.step);
			},
		    'UiNumberField.setCommitOnSliderChange': (targetObject: any, command: any) => {
				targetObject.setCommitOnSliderChange(command.commitOnSliderChange);
			},
		    'UiNumberField.setPrecision': (targetObject: any, command: any) => {
				targetObject.setPrecision(command.displayPrecision);
			},
		    'UiNumberField.setEmptyText': (targetObject: any, command: any) => {
				targetObject.setEmptyText(command.emptyText);
			},
		    'UiNumberField.setShowClearButton': (targetObject: any, command: any) => {
				targetObject.setShowClearButton(command.showClearButton);
			},
		    'UiCurrencyField.setDefaultCurrencyCode': (targetObject: any, command: any) => {
				targetObject.setDefaultCurrencyCode(command.defaultCurrencyCode);
			},
		    'UiCurrencyField.setCurrencyCodeList': (targetObject: any, command: any) => {
				targetObject.setCurrencyCodeList(command.currencyCodeList);
			},
		    'UiCurrencyField.setShowCurrencyBeforeAmount': (targetObject: any, command: any) => {
				targetObject.setShowCurrencyBeforeAmount(command.showCurrencyBeforeAmount);
			},
		    'UiCurrencyField.setShowCurrencySymbol': (targetObject: any, command: any) => {
				targetObject.setShowCurrencySymbol(command.showCurrencySymbol);
			},
		    'UiFileField.replaceFileItem': (targetObject: any, command: any) => {
				targetObject.replaceFileItem(command.uuid, command.data);
			},
		    'UiFileField.setItemTemplate': (targetObject: any, command: any) => {
				targetObject.setItemTemplate(command.itemTemplate);
			},
		    'UiFileField.setMaxBytesPerFile': (targetObject: any, command: any) => {
				targetObject.setMaxBytesPerFile(command.maxBytesPerFile);
			},
		    'UiFileField.setUploadUrl': (targetObject: any, command: any) => {
				targetObject.setUploadUrl(command.uploadUrl);
			},
		    'UiFileField.setDisplayType': (targetObject: any, command: any) => {
				targetObject.setDisplayType(command.displayType);
			},
		    'UiFileField.setMaxFiles': (targetObject: any, command: any) => {
				targetObject.setMaxFiles(command.maxFiles);
			},
		    'UiFileField.setUploadButtonTemplate': (targetObject: any, command: any) => {
				targetObject.setUploadButtonTemplate(command.uploadButtonTemplate);
			},
		    'UiFileField.setUploadButtonData': (targetObject: any, command: any) => {
				targetObject.setUploadButtonData(command.uploadButtonData);
			},
		    'UiFileField.setShowEntriesAsButtonsOnHover': (targetObject: any, command: any) => {
				targetObject.setShowEntriesAsButtonsOnHover(command.showEntriesAsButtonsOnHover);
			},
		    'UiCheckBox.setCaption': (targetObject: any, command: any) => {
				targetObject.setCaption(command.caption);
			},
		    'UiCheckBox.setBackgroundColor': (targetObject: any, command: any) => {
				targetObject.setBackgroundColor(command.backgroundColor);
			},
		    'UiCheckBox.setCheckColor': (targetObject: any, command: any) => {
				targetObject.setCheckColor(command.checkColor);
			},
		    'UiCheckBox.setBorderColor': (targetObject: any, command: any) => {
				targetObject.setBorderColor(command.borderColor);
			},
		    'AbstractUiTimeField.setShowDropDownButton': (targetObject: any, command: any) => {
				targetObject.setShowDropDownButton(command.showDropDownButton);
			},
		    'AbstractUiTimeField.setTimeFormat': (targetObject: any, command: any) => {
				targetObject.setTimeFormat(command.timeFormat);
			},
		    'AbstractUiTimeField.setShowClearButton': (targetObject: any, command: any) => {
				targetObject.setShowClearButton(command.showClearButton);
			},
		    'UiInstantTimeField.setTimeZoneId': (targetObject: any, command: any) => {
				targetObject.setTimeZoneId(command.timeZoneId);
			},
		    'AbstractUiDateField.setShowDropDownButton': (targetObject: any, command: any) => {
				targetObject.setShowDropDownButton(command.showDropDownButton);
			},
		    'AbstractUiDateField.setFavorPastDates': (targetObject: any, command: any) => {
				targetObject.setFavorPastDates(command.favorPastDates);
			},
		    'AbstractUiDateField.setDateFormat': (targetObject: any, command: any) => {
				targetObject.setDateFormat(command.dateFormat);
			},
		    'AbstractUiDateField.setShowClearButton': (targetObject: any, command: any) => {
				targetObject.setShowClearButton(command.showClearButton);
			},
		    'UiInstantDateField.setTimeZoneId': (targetObject: any, command: any) => {
				targetObject.setTimeZoneId(command.timeZoneId);
			},
		    'AbstractUiDateTimeField.setShowDropDownButton': (targetObject: any, command: any) => {
				targetObject.setShowDropDownButton(command.showDropDownButton);
			},
		    'AbstractUiDateTimeField.setFavorPastDates': (targetObject: any, command: any) => {
				targetObject.setFavorPastDates(command.favorPastDates);
			},
		    'AbstractUiDateTimeField.setDateFormat': (targetObject: any, command: any) => {
				targetObject.setDateFormat(command.dateFormat);
			},
		    'AbstractUiDateTimeField.setTimeFormat': (targetObject: any, command: any) => {
				targetObject.setTimeFormat(command.timeFormat);
			},
		    'UiInstantDateTimeField.setTimeZoneId': (targetObject: any, command: any) => {
				targetObject.setTimeZoneId(command.timeZoneId);
			},
		    'UiButton.setTemplate': (targetObject: any, command: any) => {
				targetObject.setTemplate(command.template);
			},
		    'UiButton.setData': (targetObject: any, command: any) => {
				targetObject.setData(command.data);
			},
		    'UiButton.setColor': (targetObject: any, command: any) => {
				targetObject.setColor(command.color);
			},
		    'UiDropDownButton.setDropDownWidth': (targetObject: any, command: any) => {
				targetObject.setDropDownWidth(command.dropDownWidth);
			},
		    'UiDropDownButton.setDropDownComponent': (targetObject: any, command: any) => {
				targetObject.setDropDownComponent(command.dropDownComponent);
			},
		    'UiComboBox.setDropDownData': (targetObject: any, command: any) => {
				targetObject.setDropDownData(command.data);
			},
		    'UiComboBox.updateNodes': (targetObject: any, command: any) => {
				targetObject.updateNodes(command.nodeList);
			},
		    'UiSlider.setMin': (targetObject: any, command: any) => {
				targetObject.setMin(command.min);
			},
		    'UiSlider.setMax': (targetObject: any, command: any) => {
				targetObject.setMax(command.max);
			},
		    'UiSlider.setStep': (targetObject: any, command: any) => {
				targetObject.setStep(command.step);
			},
		    'UiSlider.setDisplayedDecimals': (targetObject: any, command: any) => {
				targetObject.setDisplayedDecimals(command.displayedDecimals);
			},
		    'UiSlider.setSelectionColor': (targetObject: any, command: any) => {
				targetObject.setSelectionColor(command.selectionColor);
			},
		    'UiSlider.setTooltipPrefix': (targetObject: any, command: any) => {
				targetObject.setTooltipPrefix(command.tooltipPrefi);
			},
		    'UiSlider.setTooltipPostfix': (targetObject: any, command: any) => {
				targetObject.setTooltipPostfix(command.tooltipPostfi);
			},
		    'UiSlider.setHumanReadableFileSize': (targetObject: any, command: any) => {
				targetObject.setHumanReadableFileSize(command.humanReadableFileSize);
			}
	};

	public static executeCommand(targetObject: any, command: any) {
		this.commandExecutorsByCommandName[command._type](targetObject, command);
	}

}